var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, FlexBox, IconButton, Table } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { PureComponent } from 'react';
import { analytics } from 'app/utils/segment';
import styles from '../teamsAgents.module.scss';
export class TeamsAgentsTableRow extends PureComponent {
    handleClick() {
        analytics.settingsTeamDetailsAddAgentsButtonClicked();
        const { teamAgent, showRemoveModal } = this.props;
        showRemoveModal(teamAgent);
    }
    render() {
        const { teamAgent } = this.props;
        return (_jsxs(Table.Tr, { children: [_jsx(Table.Td, { children: _jsxs(FlexBox, Object.assign({ alignItems: "center" }, { children: [_jsx("div", Object.assign({ className: styles.avatarWrap }, { children: _jsx(Avatar, { user: teamAgent }) })), teamAgent.name] })) }), _jsx(Table.Td, { children: teamAgent.email }), _jsx(Table.Td, { children: _jsx(IconButton, { variant: "tertiary", icon: "trash", onClick: this.handleClick }) })] }));
    }
}
__decorate([
    boundMethod
], TeamsAgentsTableRow.prototype, "handleClick", null);
